import { render, staticRenderFns } from "./register-card.vue?vue&type=template&id=3a4fc6b4&scoped=true"
import script from "./register-card.vue?vue&type=script&lang=js"
export * from "./register-card.vue?vue&type=script&lang=js"
import style0 from "./register-card.vue?vue&type=style&index=0&id=3a4fc6b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a4fc6b4",
  null
  
)

export default component.exports